import { useState } from 'react';
import { NJButton, NJSegmentedControl, NJSegmentedControlButton, NJText } from '@engie-group/fluid-design-system-react';
import { UMIcon, UMR } from '../../urbanmap/_components';
import { computePermissions, isViewerId, VIEWER_IDS, VIEWERS, viewerFromSearch, type Viewer } from './permissions';
export type { Viewer } from './permissions';

export function ViewerSwitcher({ viewer, onChange }: { viewer: Viewer; onChange: (viewer: Viewer) => void }) {
  const [open, setOpen] = useState(false);
  const current = VIEWERS[viewer];
  const rights = computePermissions(viewer);
  return <aside style={{ position: 'fixed', right: 16, bottom: 36, zIndex: 1000, width: 330, border: `1px dashed ${UMR.logoText}`, background: UMR.white, padding: 12, fontFamily: UMR.font }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <UMIcon name="science" size={18} />
      <NJText scale="sm" style={{ margin: 0, fontWeight: 700, flex: 1 }}>Prototype — Voir en tant que</NJText>
      <NJButton label={open ? 'Réduire' : 'Déplier'} variant="secondary" emphasis="minimal" scale="sm" onClick={() => setOpen(!open)} />
    </div>
    {open && <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginTop: 10 }}>
      <NJSegmentedControl label="Simuler un profil d’accès" value={viewer} size="sm" onChange={(value) => { if (isViewerId(value)) onChange(value); }}>
        {VIEWER_IDS.map((id) => <NJSegmentedControlButton key={id} value={id} label={VIEWERS[id].label} />)}
      </NJSegmentedControl>
      <NJText scale="xs" style={{ margin: 0 }}>{current.name} · {current.group}</NJText>
      <NJText scale="xs" style={{ margin: 0, color: UMR.textSecondary }}>{current.reason}</NJText>
      <NJText scale="xs" style={{ margin: 0 }}>
        Consultation / exports : oui · Édition : {rights.canEdit ? 'oui' : 'non'} · Suppression : {rights.canDelete ? 'selon usage' : 'non'}.
        Gestion des accès : {rights.canManageAccess ? 'propriétaire, hors simulation' : 'non'}.
      </NJText>
      <NJButton label="Réinitialiser les données" variant="secondary" scale="sm" onClick={() => window.location.reload()} />
    </div>}
  </aside>;
}
export const readViewerFromUrl = (): Viewer => viewerFromSearch(window.location.search);
